import { Navigate, Outlet } from "react-router-dom";
import { OnboardingGate } from "./onboardingGate";

export const ProtectedRoute = ({
  isAuthenticated = false,
  redirectPath = "/auth",
}) => {
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <OnboardingGate>
      <Outlet />
    </OnboardingGate>
  );
};
